
import React, { useState, useEffect } from "react";
import Contact from "../../components/Contact/contact";
import QuoteGenerator from "../../components/Quote/quote";
import Competence from "../../components/competences/competence";

import loadingImage from "../../assets/images/disque.png"; // Assurez-vous que le chemin est correct
import "./home.css"; // Assurez-vous que le chemin est correct

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [text, setText] = useState("");
  const fullText = "DDéveloppeuse Passionnée";
  const typingSpeed = 110;

  useEffect(() => {
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
      startTyping();
    }, 2000); // Temps en millisecondes

    return () => {
      clearTimeout(loadingTimeout);
    };
  }, []);

  const startTyping = () => {
    let index = 0;
    const typingInterval = setInterval(() => {
      setText((prevText) => prevText + fullText.charAt(index));
      index++;

      if (index === fullText.length) {
        clearInterval(typingInterval);
      }
    }, typingSpeed);
  };

  return (
    <>
      <div className="home">
        <div className="loading">
          {isLoading ? (
            <div className="loading-animation">
              <img
                src={loadingImage}
                alt="Loading"
                className="loading-image rotating"
              />
              <p>Chargement...</p>
            </div>
          ) : (
            <div className="home-text">
              <h1>{text}</h1>
              <p>
                Je suis Nadia, une développeuse passionnée par la programmation. Curieuse et déterminée, j’ai acquis mes compétences grâce à l’auto-apprentissage et à une pratique constante. Toujours avide de découvrir de nouvelles technologies, j’avance pas à pas dans un parcours en évolution continue. Mon portfolio reflète cette passion et mon engagement, en partageant mes projets, ma créativité et ma progression en tant que développeuse.

Actuellement, je travaille sur un projet de jeu AAA-like — ambitieux, riche et exigeant — que je présenterai une fois terminé. Cette expérience me pousse à réfléchir à l’architecture, à la scalabilité, aux performances extrêmes et aux meilleures technologies pour produire un résultat de haut niveau.
              </p>
              <div className="competencess">
                <h2>Mes compétences</h2>
                <Competence />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="Quote-Generateur">
        <QuoteGenerator />
      </div>
      <div className="contact-section" id="contact">
        <Contact />
      </div>

  
     
    </>
  );
};

export default Home;
